module.exports = __webpack_public_path__ + "1792771649312/fonts/Comfortaa-Light.929fd78.ttf";